export default __webpack_public_path__ + "img/eOevkcjy.cfe99c0b.svg";